enum HistoryEntryType {
    Update = "UPDATE",
    Create = "CREATE",
    Delete = "DELETE",
    Add = "ADD",
    Remove = "REMOVE",
}
export default HistoryEntryType